// Keycloak mints the CUSTOM_ATTRIBUTES pseudo-type's roles hyphenated (its catalog id is
// "CUSTOM-ATTRIBUTES"), not with the underscore callers spell it with — the role that can
// actually be granted would otherwise never match. Mirrors the backend's own alias handling for
// the same gap (zdb-entity-service AccessService.kt, ZDB-7159).
const FEATURE_TYPE_ALIASES: Record<string, string[]> = {
  CUSTOM_ATTRIBUTES: ['CUSTOM_ATTRIBUTES', 'CUSTOM-ATTRIBUTES']
}

// All FEAT_<type>_<level> spellings a feature type's roles may be granted under.
export function featureRoleAliases(featureType: string): string[] {
  return FEATURE_TYPE_ALIASES[featureType.toUpperCase()] ?? [featureType.toUpperCase()]
}
